import * as actionTypes from '../actions/actionTypes';
import {updateState} from '../../shared/util';

const initialState = {
    cart: [],
    loading: false,
    error: null
};

function getCart() {
    const cart = localStorage.getItem('cart');
    if (cart !== null) {
        return JSON.parse(cart);
    } else {
        return [];
    }
}

function addToCart(cartItem, state) {
    const cart = getCart();
    cart.unshift(cartItem);
    localStorage.setItem('cart', JSON.stringify(cart));

    return updateState(state, {
       loading: false,
       cart: getCart()
    });
}

function removeFromCart(id, state) {
    const filteredCart = getCart().filter(item => item.id !== id);
    localStorage.setItem('cart', JSON.stringify(filteredCart));

    return updateState(state, {
        cart: getCart()
    });
}

const clearCart = (state) => {
    localStorage.setItem('cart', '[]');
    return updateState(state, {
        cart: []
    });
};

export function cartReducer(state=initialState, action) {
    switch (action.type) {
        case actionTypes.ADD_TO_CART: return addToCart(action.item);
        case actionTypes.DELETE_FROM_CART: return removeFromCart(action.id);
        case actionTypes.GET_CART_DATA: return updateState(state, {cart: getCart()});
        case actionTypes.RUN_TRANSACTIONS_SUCCESS: return clearCart(state);
        default: return state;
    }
}